import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from '@googlemaps/markerclusterer';

const mapKey = document.body.dataset.mapsKey;

const loader = new Loader({
  apiKey: mapKey,
  version: 'weekly',
  libraries: ['places'],
});

function addMarker(map, google, wrapper, data) {
  const marker = new window.google.maps.Marker({
    map,
    title: data.Title,
    position: {
      lat: parseFloat(data.Latitude),
      lng: parseFloat(data.Longitude),
    },
    icon: data.Icon,
    id: data.ID,
  });

  google.maps.event.addListener(marker, 'click', () => {
    const mapsList = wrapper.querySelector('.maps-list');

    mapsList.querySelectorAll('li.highlight').forEach((highlighted) => {
      highlighted.classList.remove('highlight');
    });

    mapsList.querySelectorAll('li[data-id="' + marker.id + '"]').forEach((listItem) => {
      listItem.classList.add('highlight');
      listItem.scrollIntoView({
        behavior: 'smooth',
      });
    });
  });

  return marker;
}

function initMaps(google) {
  const mapsWrappers = document.querySelectorAll('.maps-wrapper');

  mapsWrappers.forEach((wrapper) => {
    initMap(google, wrapper);
  });
}

function initMap(google, wrapper) {
  const { lat, lng } = wrapper.dataset;
  const passedMarkers = JSON.parse(atob(wrapper.dataset.json));

  if (document.getElementById('map')) {
    const map = new google.maps.Map(document.getElementById('map'), {
      zoom: 12,
      disableDefaultUI: true,
      zoomControl: true,
    });

    const bounds = new google.maps.LatLngBounds();
    const markers = [];

    passedMarkers.forEach((element) => {
      const marker = addMarker(map, google, wrapper, element);
      markers.push(marker);
      bounds.extend(marker.position);
    });

    new MarkerClusterer({
      map,
      markers,
      renderer: {
        render: ({ count, position }, stats) => {
          const numberOfMarkerImages = 3;
          let imageNumber = Math.floor(count / (stats.clusters.markers.max / numberOfMarkerImages));

          if (imageNumber !== numberOfMarkerImages) {
            imageNumber += 1;
          }

          return new google.maps.Marker({
            position,
            icon: {
              url: `resources/themes/dutchgymnastics/images/markers/m${imageNumber}.png`,
            },
            label: {
              text: String(count),
              color: 'rgba(255,255,255,0.9)',
              fontSize: '12px',
            },
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
          });
        },
      },
    });

    if (lat && lng) {
      map.setCenter({
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      });
    } else {
      map.fitBounds(bounds);
    }
  }
}

if (document.querySelectorAll('.maps-wrapper').length) {
  loader
    .load()
    .then(initMaps)
    .catch(console.error);
}
